/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation DltDirectoryDeleteMutation($dltDirectoryId: ID!) {
  DltDirectoryDelete(dltDirectoryId: $dltDirectoryId) {
    id
    message
    status
  }
}
`
